import * as preregisterApplicantsTypes from './preregisterApplicantsTypes';

const initialState = {
  dateFrom_input: undefined,
  dateTo_input: undefined,
  clientIndex: undefined,
  clientId: undefined,
  pathwayIndex: undefined,
  pathwayId: undefined,
  entityIndex: undefined,
  entityId: undefined,
  daysOldIndex: undefined,
  daysOldId: undefined,
  casePhaseIndex: undefined,
  casePhaseId: undefined,
  countryId: undefined,
  countryIndex: undefined,
  yearId: undefined,
  yearIndex: undefined,
  filter: undefined,
  eyStatusId: undefined,
  eyStatusIndex: undefined,
  enableApplyBtn: false,
};

const moveApplicantFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case preregisterApplicantsTypes.CLEAR_FILTER:
      return { ...state, ...initialState};

    case preregisterApplicantsTypes.ON_CHANGE:
      return {
        ...state,
        enableApplyBtn: true,
        ...action.payload,
      };

    case preregisterApplicantsTypes.ON_CHANGE_DATE:
      return {
        ...state,
        ...action.payload,
      };
    case preregisterApplicantsTypes.GET_FILTERS_SUCCESS:
        return {
            ...state,
            filters: action.payload,
        };
    default:
      return state;
  }
};

export { initialState };
export default moveApplicantFilterReducer;
